import { styled } from '@mui/material/styles';

export const FilledAutocompleteWrapper = styled('div')(({ theme }) => ({
  '& .MuiAutocomplete-endAdornment:after': {
    content: "''",
    display: 'block',
    position: 'absolute',
    top: '50%',
    right: theme.spacing(25),
    width: theme.spacing(1),
    height: '60%',
    background: theme.palette.grey['300'],
    transform: 'translateY(-50%)',
  },
  '& .MuiFormControl-root > .MuiInputBase-root': {
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 0,
    height: theme.spacing(30),
    minHeight: 'auto',
  },
  '& .MuiFormLabel-root': {
    visibility: 'hidden',
  },
  '& .MuiFormControl-root > .MuiInputBase-root > fieldset': {
    border: 'none',
  },
  '&  .MuiAutocomplete-root': {
    width: theme.spacing(300),
  },
}));
